import { createSlice } from "@reduxjs/toolkit";
import initialState from "../../configs/redux/initialState";

const dialogPolicyPointReducer = createSlice({
  name: "dialogPolicyPointReducer",
  initialState: initialState.dialogPolicyPointReducer,
  reducers: {
    whatYouNeed: (state, action) => {
      state.whatYouNeed = action.payload;
    },
    redeemPoints: (state, action) => {
      state.redeemPoints = action.payload;
    },
    setMissionsLoading: (state, action) => {
      state.missionsLoading = !!action.payload;
    },
    setRewardMissions: (state, action) => {
      const payload = action.payload || {};
      state.missions = Array.isArray(payload.missions) ? payload.missions : [];
      state.missionPoints = typeof payload.points === "number" ? payload.points : 0;
      state.missionsLoaded = true;
      state.missionsLoading = false;
    },
    setRewardMissionsError: (state) => {
      state.missionsLoading = false;
      if (!state.missionsLoaded) {
        state.missions = [];
        state.missionPoints = null;
      }
    },
  }
});

export const {
    whatYouNeed,
    redeemPoints,
    setMissionsLoading,
    setRewardMissions,
    setRewardMissionsError,
} = dialogPolicyPointReducer.actions;

export default dialogPolicyPointReducer.reducer;
